import SettingOther from './components/setting-other-form';
import SettingSection from './components/setting-section';
import SettingCancelBooking from './components/setting-cancel-booking';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/hooks/useStore';
import { useEffect } from 'react';
import { flowResult } from 'mobx';
import SettingBikeTime from './components/setting-bike-time';
import { SYSTEM_SETTING_TYPE } from '@/types/enums';
import { useTranslation } from 'react-i18next';

export default observer(function SystemSettingPage() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        systemSettingStore: {
            systemSetting,
            getSystemSetting, updateSystemSetting,
            clean
        },
        modalStore: { showAlertModal }
    } = useStore();

    // lifecycle
    useEffect(() => {
        fetchSystemSetting();

        return () => {
            clean();
        };
    }, []);

    const fetchSystemSetting = async () => {
        await flowResult(getSystemSetting());
    };

    const handleUpdateSystemSetting = async (payload) => {
        const res = await flowResult(updateSystemSetting(payload));
        if (res) {
            showAlertModal({
                id: 'update-setting-bike-success',
                type: 'success',
                content: t('messages.update_success')
            });
        }
    };

    return (
        <>
            <SettingSection
                title={t('system_setting.setting_cancel_booking.title')}
                content={(
                    <SettingCancelBooking
                        cancelBooking={systemSetting?.cancelbooking}
                        onCancelBookingSubmit={(value) => {
                            const paylaod = { settingType: SYSTEM_SETTING_TYPE.CANCEL_BOOKING, data: value };
                            handleUpdateSystemSetting(paylaod);
                        }}
                    />
                )}
            />

            <SettingSection
                title={t('system_setting.setting_bike_arrangement_completion_time.title')}
                content={(
                    <SettingBikeTime
                        preparationTimeConfig={systemSetting?.preparationTimeConfig || []}
                    />
                )}
                className='mt-6'
            />

            <SettingSection
                title={t('system_setting.setting_other.title')}
                content={(
                    <SettingOther
                        other={systemSetting?.other}
                        onOrderSubmit={(value) => {
                            const paylaod = { settingType: SYSTEM_SETTING_TYPE.OTHER, data: value };
                            handleUpdateSystemSetting(paylaod);
                        }}
                    />
                )}
                className='mt-6'
            />

        </>
    );
});
